import { render } from "./Radio.vue?vue&type=template&id=59f9c545"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"
script.render = render

export default script